import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ShieldCheckIcon } from 'lucide-react';
export function WhyUs() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1000">
      <Navbar data-id="element-1001" />
      <main className="flex-1" data-id="element-1002">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-1003">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1004">
            <div className="inline-flex items-center gap-2 bg-soft-teal text-accent-teal-dark text-xs font-semibold px-3 py-1.5 rounded-full mb-4" data-id="element-1005">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-1006" />
              Nurse-Owned & Operated
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-1007">
              Why Choose Care Nomad?
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-1008">
              We are Canada's first nurse-led healthcare staffing marketplace,
              built by healthcare professionals for healthcare professionals.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16 text-text-muted leading-relaxed space-y-6" data-id="element-1009">
          <p data-id="element-1010">
            At Care Nomad, we understand the unique challenges of healthcare
            staffing because we've lived them. Our founder, Ese Uko, is a
            Co-Owner and Chief Recruiter who brings years of frontline
            experience to our platform.
          </p>
          <p data-id="element-1011">
            We believe that quality care starts with quality caregivers. That's
            why every professional on our platform is vetted and managed by a
            Registered Nurse and former PSW — ensuring clinical standards you
            can trust. We verify credentials, conduct clinical competency
            assessments, and run criminal background checks to ensure the
            highest level of safety and quality.
          </p>
          <p data-id="element-1012">
            Our direct marketplace model cuts out the middleman, passing savings
            directly to facilities while offering higher take-home pay for
            workers. This means better retention, higher quality of care, and a
            more sustainable healthcare system for everyone.
          </p>
        </div>
      </main>
      <StickyFooter data-id="element-1013" />
    </div>;
}